// extracted by mini-css-extract-plugin
module.exports = {"SliderButtons":"Buttons_SliderButtons__2P2ty","StageButton":"Buttons_StageButton__1L0Kn","Active":"Buttons_Active__2AkUV"};